import { connect } from 'react-redux';

import FlagEnabled from './FlagEnabled';
import { selectors } from '../../dux/user';

const mapStateToProps = (state) => ({
  flags: selectors.getFeatureFlagsState(state, false).flags,
});

export default connect(mapStateToProps, {})(FlagEnabled);
